export default "__VITE_ASSET__DjWCwdIC__"